import { Body1, SelectionCard, Stack, Subtitle1, Subtitle2 } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/offer-pricing/OfferPriceButton.tsx
const OfferPriceButton = ({ price, onClick, title, subtitle, isSelected }) => {
	return /* @__PURE__ */ jsx(SelectionCard, {
		isSelected: !!isSelected,
		color: "primary",
		onClick,
		children: /* @__PURE__ */ jsxs(Stack, {
			gap: "xxxs",
			children: [
				/* @__PURE__ */ jsx(Subtitle2, { children: title }),
				price && /* @__PURE__ */ jsx(Subtitle1, { children: price }),
				/* @__PURE__ */ jsx(Body1, { children: subtitle })
			]
		})
	});
};

//#endregion
export { OfferPriceButton };